import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, UntypedFormControl, NgControl } from '@angular/forms';

@Component({
	selector: 'app-textarea-input',
	templateUrl: './textarea-input.component.html',
	providers: [
		{
			provide: [],
			useExisting: forwardRef(() => TextareaInputComponent),
			multi: true,
		},
	],
})
export class TextareaInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
	@Input() label?: string;
	@Input() placeholder = '';

	private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

	public disabled: boolean;
	public control: UntypedFormControl = new UntypedFormControl(null);
	public updateValue = (_: any) => {};
	public onTouched = () => {};

	constructor(public ngControl: NgControl) {
		ngControl.valueAccessor = this;
	}

	private propagateChange(value: any): void {
		if (this.updateValue) {
			return this.updateValue(value);
		}

		if (this.control) {
			this.control.setValue(value, { emitEvent: false });
		}
	}

	public ngOnInit(): void {
		this.control.valueChanges.pipe(
			takeUntil(this.componentDestroyed$),
		).subscribe((value) => {
			this.propagateChange(value);
		});
	}

	public ngOnDestroy(): void {
		this.componentDestroyed$.next(true);
		this.componentDestroyed$.complete();
	}

	public writeValue(value: any): void {
		// emitEvent: false — otherwise the initial writeValue propagates back
		// through valueChanges → onChange and marks the parent control dirty
		// on load, which makes validation errors appear before any interaction.
		setTimeout(() => this.control.setValue(value, { emitEvent: false }));
	}

	public registerOnChange(fn: any): void {
		this.updateValue = fn;
	}

	public registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	public onBlur(): void {
		this.onTouched();
	}

	public setDisabledState(isDisabled: boolean) {
		this.disabled = isDisabled;
	}
}
